import classNames from 'classnames';
import { string, bool, oneOf } from 'prop-types';
import React from 'react';

import css from './FieldColor.module.css';

const FieldColor = ({ className, label, value, size, withoutLabel, intl }) => {
  return (
    <div className={classNames(css.color, className)}>
      <span
        className={classNames(css.icon, css[size])}
        style={{
          background: value,
        }}
      />
      {!withoutLabel && <span>{label}</span>}
    </div>
  );
};

FieldColor.defaultProps = {
  value: null,
  size: 'medium',
  withoutLabel: false,
  label: '',
};

FieldColor.propTypes = {
  value: string,
  label: string,
  size: oneOf(['small', 'medium', 'large']),
  withoutLabel: bool,
};

export default FieldColor;
